import SELFINVEST_EXT_1 from "./SELFINVEST_EXT_1";

export default {
  SELFINVEST_EXT_1,
};
